import resolveEncodedColor from "@toolkit/Framework/Common/Utilities/resolveEncodedColor";

export default (color = "") => {
    return ({ theme }: any) => resolveEncodedColor(color, theme);
};
